var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9088 3.10925L27.0797 25.8831C26.7151 27.4901 25.7653 27.8902 24.4154 27.1335L17.0569 21.7112L13.5068 25.1264C13.1137 25.5196 12.7856 25.8477 12.0278 25.8477L12.557 18.3543L26.1939 6.03185C26.7871 5.50379 26.0648 5.21004 25.2727 5.73924L8.41374 16.3552L1.15582 14.083C-0.422631 13.5904 -0.451205 12.5045 1.485 11.7467L29.8732 0.809577C31.1876 0.316953 32.3374 1.10218 31.9088 3.11039V3.10925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlack);
export default __webpack_public_path__ + "static/media/telegram-black.b0c25c4c6a4e9fc9598b5c25a9de850c.svg";
export { ForwardRef as ReactComponent };